import { useEffect, useState, type InputHTMLAttributes } from "react";
import { formatAmountBare, parseAmount } from "../format.ts";

type Props = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "value" | "onChange" | "type" | "defaultValue"
> & {
  value: number;
  onChange: (n: number) => void;
};

export function CurrencyInput({ value, onChange, onBlur, ...rest }: Props) {
  const [draft, setDraft] = useState(() => formatAmountBare(value));
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (!focused) setDraft(formatAmountBare(value));
  }, [value, focused]);

  return (
    <input
      {...rest}
      type="text"
      inputMode="decimal"
      value={draft}
      onFocus={(e) => {
        setFocused(true);
        e.currentTarget.select();
        rest.onFocus?.(e);
      }}
      onChange={(e) => {
        const next = e.currentTarget.value;
        setDraft(next);
        const n = parseAmount(next);
        onChange(Number.isFinite(n) ? n : 0);
      }}
      onBlur={(e) => {
        setFocused(false);
        setDraft(formatAmountBare(value));
        onBlur?.(e);
      }}
    />
  );
}
